import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ReclamationCausesDataGrid } from "src/components/views/erp/reclamation/masterData/ReclamationCausesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/reclamations/reclamationCause")({
	staticData: { title: i18n.t("reclamation_causes"), legacyViewKey: "reclamationCausesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ReclamationCausesDataGrid />;
}
